import { createContext } from 'react';

import { UtilityAccount } from '@totem/components/portfolio/buildings/details/utilities/types';

interface Context {
  loading: boolean;
  data: UtilityAccount[];
  buildingId: string;
  requestRefresh: () => void;
}

export default createContext<Context>({
  loading: false,
  data: [],
  buildingId: '',
  requestRefresh: () => {},
});
